import { render, staticRenderFns } from "./FirstChildAction.vue?vue&type=template&id=0f9b2964&scoped=true&"
import script from "./FirstChildAction.vue?vue&type=script&lang=js&"
export * from "./FirstChildAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b2964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9b2964')) {
      api.createRecord('0f9b2964', component.options)
    } else {
      api.reload('0f9b2964', component.options)
    }
    module.hot.accept("./FirstChildAction.vue?vue&type=template&id=0f9b2964&scoped=true&", function () {
      api.rerender('0f9b2964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/albert/albertprod/albertreport/FirstChildAction.vue"
export default component.exports